import { render } from "./AgentRates.vue?vue&type=template&id=6030e084"
import script from "./AgentRates.vue?vue&type=script&lang=js"
export * from "./AgentRates.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__